import request from '@core/services/request';

export const autoCompleteAPI = {
	createVerificationFromCustomer: (customerId: any, storeCode: any) =>
		request.post(`/AutoComplete/CreateVerification/FromCustomer`, {
			idToLookup: customerId,
			storeCode,
			autoCreateAssociations: true,
		}),
	createVerificationFromDeal: (dealId: any, dealKind: any, storeCode: any, includeCoCustomer: any = false) =>
		request.post(`/AutoComplete/CreateVerification/FromDeal?dealKind=${dealKind}&includeCoCustomer=${includeCoCustomer}`, {
			idToLookup: dealId,
			storeCode,
			autoCreateAssociations: true,
		}),
	getVerification: (verificationId: any, associations: any[] = []) =>
		request.post(`/AutoComplete/GetVerification/${verificationId}`, {
			associations,
		}),
	createLeadFromDeal: (dealId: any, dealKind: any, storeCode: any, includeCoCustomer: any = false) =>
		request.post(`/AutoComplete/CreateLead/FromDeal?dealKind=${dealKind}&includeCoCustomer=${includeCoCustomer}`, {
			idToLookup: dealId,
			storeCode,
			autoCreateAssociations: true,
		}),
	getLead: (leadId: any, associations: any[] = []) => request.post(`/AutoComplete/GetLead/${leadId}`, { associations }),
	findExchangesByAssociation: (associations: any, matchAll: any = true, exchangeType = -1) =>
		request.post(`/AutoComplete/LookupExchangesByAssociations?exchangeType=${exchangeType}`, {
			associations,
			matchAll,
		}),
	findLatestExchange: (associations: any[], matchAll = true, exchangeType = -1) =>
		request.post(`/AutoComplete/LookupLatestExchange?exchangeType=${exchangeType}`, { associations, matchAll }),
	findAllLatestExchanges: (associations: any, matchAll = true) =>
		request.post(`/AutoComplete/LookupLatestExchanges/All`, {
			associations,
			matchAll,
		}),
	findLatestExchangeResults: (associations: any, matchAll = true, exchangeType = -1) =>
		request.post(`/AutoComplete/LookupLatestExchangeResults?exchangeType=${exchangeType}`, {
			associations,
			matchAll,
		}),
	findLatestQuote: (customerId: any) => request.get(`/AutoComplete/LookupLatestQuote?customerId=${customerId}`),
	getLinkToPortal: (appDomain: any, customerId: any) => request.post(`/AutoComplete/GetPortalLink`, { appDomain, customerId }),
	sendLinkToPortal: (generateLinkRequest: any) => request.post(`/AutoComplete/SendPortalLink`, generateLinkRequest),
};
